import React, { FC, PropsWithChildren } from 'react';

export interface IBlog {
    onCloseContent: () => void;
}

const Blog: FC<IBlog> = (props: PropsWithChildren<IBlog>) =>  {
    const {
        onCloseContent
    } = props;

    return (
        <div className="help-center-container">
            <div className="help-center-header">
                <h4>Blog</h4>
                <i className="close-btn"
                   onClick={() => onCloseContent()}
                   role="button"
                   onKeyPress={(e) => e.preventDefault()}
                   tabIndex={0}
                   aria-label="close content"
                />
            </div>
        </div>
    );
}

export default Blog;
